const contactConfig = {
    YOUR_EMAIL: '  scienceacademy0128@gmail.com',
    YOUR_FONE: '  +91-8149397762',
    description:
      'Our pleasure to talk with you !',
    // YOUR_SERVICE_ID: 'service_id',
    // YOUR_TEMPLATE_ID: 'template_id',
    // YOUR_USER_ID: 'user_id',
    location: '  Nallasopara (W) , Mumbai' ,
  };
  
   
  export {

    contactConfig
    
  };
